





















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ImageSrc } from '@/utils/types.ts'

import ImageUploaderButton from '@/components/ImageUploaderButton.vue'

import BackgroundImage from '@/store/current/backgroundImage.ts'
import Composition from '@/store/current/composition.ts'
import GalleryImages from '@/store/galleryImages.ts'

const backgroundImage = getModule(BackgroundImage)
const composition = getModule(Composition)
const galleryImages = getModule(GalleryImages)

@Component({
  components: {
    ImageUploaderButton
  }
})
export default class Gallery extends Vue {
  get imageSrcs (): Map<string, ImageSrc> {
    return galleryImages.asMap
  }
  get imageSrcsArray (): ImageSrc[] {
    return [...this.imageSrcs.values()]
  }
  get srcsArray (): string[] {
    return [...this.imageSrcs.keys()]
  }
  get selected (): number {
    return this.srcsArray.indexOf(backgroundImage.src)
  }
  set selected (idx: number) {
    composition.fromSrc(this.srcsArray[idx])
    this.$emit('selected')
  }
  addFiles (files: File[]) {
    galleryImages.appendFilesArray(files)
    files = []
  }
}
